import { render, staticRenderFns } from "./simultaneousInterpretation.vue?vue&type=template&id=e0b8f540&scoped=true"
import script from "./simultaneousInterpretation.vue?vue&type=script&lang=js"
export * from "./simultaneousInterpretation.vue?vue&type=script&lang=js"
import style0 from "./simultaneousInterpretation.vue?vue&type=style&index=0&id=e0b8f540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b8f540",
  null
  
)

export default component.exports